import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Button, Card, Col, Dropdown, Form, Row } from "react-bootstrap";
import { faEllipsisVertical, faPlus, faPencil, faBook } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import SubjectService from "../../services/subjects.service";
import CustomToggle from "../../Menu/CustomMenu";
import TablePagination from "../../components/Pagination/Table.paginaition";
import { StringHelper } from "../../helper/string.helper";
import EditSubject from "../../Modal/EditSubject.modal";
import AddSubject from "../../Modal/AddSubject.modal";
import UpdateSubjectModal from "../../Modal/UpdateSubject.modal";

// Accent palette cycled across subject cards — presentation only.
const SUBJECT_ACCENTS = ["#2563eb", "#0891b2", "#16a34a", "#7c3aed", "#d97706", "#db2777", "#14b8a6", "#ea580c"];

export default function UpdatedSubjectIndex() {

    const navigate = useNavigate();

    const [subjects, setSubjects] = useState<any>();
    const [editSubject, setEditSubject] = useState<any>(undefined);
    const [addSubjectShow, setAddSubjectShow] = useState<boolean>(false);
    const [subjectIndex, setSubjectIndex] = useState<any>(undefined);

    const [searchText, setSearchText] = useState<string>("");
    const [totalCount, setTotalCount] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [perPage, setPerPage] = useState<number>(10);

    const getAllSubjects = async () => {
        await SubjectService.getAllSubjects(searchText, currentPage, perPage).then((res) => {
            if (res.status == 200) {
                setSubjects(res.data.subjects)
                setTotalCount(res.data.totalSubjects)
            }
        }).catch((err) => {
            console.log(err);

        })
    }

    useEffect(() => {
        getAllSubjects();
    }, [editSubject, addSubjectShow, searchText, currentPage, perPage])


    return (
        <>
            <EditSubject
                subjectId={editSubject}
                setShow={() => setEditSubject(undefined)}
            />

            <AddSubject
                show={addSubjectShow}
                setShow={setAddSubjectShow}
            />
            <div className="ds-page-head">
                <div className="ds-page-head__text">
                    <h1 className="ds-page-head__title">Subjects</h1>
                    <p className="ds-page-head__sub">{subjects?.length || 0} {subjects?.length === 1 ? "subject" : "subjects"} with their topics</p>
                </div>
                <div className="ds-page-head__actions">
                    <input
                        type="text"
                        className="xcn-search-bar form-control"
                        placeholder="Search subjects…"
                        onChange={(e: any) => setSearchText(e.target.value)}
                    />
                    <Button onClick={() => setAddSubjectShow(true)}>
                        <FontAwesomeIcon icon={faPlus} className="me-2" />Add Subject
                    </Button>
                </div>
            </div>

            {subjects && subjects.length > 0 ? subjects.map((data: any, index: number) => {
                const accent = SUBJECT_ACCENTS[index % SUBJECT_ACCENTS.length];
                return (
                    <Card key={data._id || index} className="ds-card-hover mb-3">
                        <Card.Body>
                            <div className="d-flex align-items-center justify-content-between" style={{ gap: 14 }}>
                                <div className="d-flex align-items-center" style={{ gap: 14, minWidth: 0, flex: 1 }}>
                                    <span className="ds-row-chip" style={{ background: `${accent}14`, color: accent }}>
                                        {String(data.name || "?").charAt(0).toUpperCase()}
                                    </span>
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                        <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                            <span style={{ fontSize: 15, fontWeight: 700, color: "var(--ds-text)" }}>{data.name}</span>
                                            <span style={{ fontSize: 11, color: "var(--ds-text-faint)", fontWeight: 600 }}>#{index + 1}</span>
                                        </div>
                                        <div className="d-flex flex-wrap" style={{ gap: 6, marginTop: 7 }}>
                                            {data.topics?.length > 0 ? data.topics.map((topic: any, ti: number) => (
                                                <span key={ti} className="ds-badge" style={{ background: `${accent}10`, color: accent }}>
                                                    {StringHelper.Truncate(topic.name, 16)}
                                                </span>
                                            )) : <span style={{ fontSize: 12.5, color: "var(--ds-text-faint)" }}>No topics yet</span>}
                                        </div>
                                    </div>
                                </div>
                                <Dropdown>
                                    <Dropdown.Toggle as={CustomToggle} id="dropxdown-custom-components">
                                        <FontAwesomeIcon icon={faEllipsisVertical} className="text-secondary xcn-link-pointer" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                        <Dropdown.Item onClick={() => setSubjectIndex(index)}>
                                            <FontAwesomeIcon icon={faPencil} className="me-2 text-secondary" />Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item onClick={() => navigate("/dash/subject/" + data._id)}>
                                            <FontAwesomeIcon icon={faPlus} className="me-2 text-primary" />Add Topics
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Card.Body>
                    </Card>
                )
            }) : (
                <Card>
                    <Card.Body>
                        <div className="ds-empty">
                            <span className="ds-empty__icon"><FontAwesomeIcon icon={faBook} /></span>
                            <div className="ds-empty__title">No subjects found</div>
                            <div className="ds-empty__sub">Add a subject to start organising topics and questions.</div>
                            <Button onClick={() => setAddSubjectShow(true)}>
                                <FontAwesomeIcon icon={faPlus} className="me-2" />Add Subject
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
            )}
            <div className="text-center mt-3">
                <TablePagination
                    total={totalCount}
                    currentPage={currentPage}
                    perPage={perPage}
                    handlePageChange={(e: number) => {
                        setCurrentPage(e)
                    }}
                    setPerPage={(e: number) => { setPerPage(e) }}
                />

            </div>

            <UpdateSubjectModal
                show={subjectIndex >= 0 ? true : false}
                handleClose={() => {
                    setSubjectIndex(undefined)
                    getAllSubjects();
                }}
                data={subjects && subjects[subjectIndex]}
            />
        </>
    )
}